<template>
  <div>
    <div
      class="d-flex align-items-center p-2">
      <span
        class="notifications-heading-mark mr-1"
        :class="{'notifications-heading-mark--marked': notification.comment.activityResult.star}" />
      <span
        v-if="notification.comment.activityResult.isLocked"
        class="material-icons goal-lock-icon">
        lock
      </span>

      <h3 class="notifications__heading">
        {{ notification.comment.activityResult.name }}
      </h3>
    </div>
    <div
      @click="onClickActivePart">
      <div class="comment p-2">
        <div
          class="comment__item">
          <div class="comment__head d-flex align-items-center justify-content-between mb-2">
            <div class="comment__content d-flex align-items-center">
              <img
                v-if="notification.comment.createdBy.avatar"
                :src="notification.comment.createdBy.avatar"
                class="img-fluid comment__img rounded-circle mr-2">
              <b-avatar
                v-else
                :text="notification.comment.createdBy.name | initial"
                class="mr-2" />
              <p class="comment__name mr-2">
                {{ notification.comment.createdBy.name }}
              </p>
              <p class="comment__date">
                {{ notification.comment.createdAt | prettyDateTime }}
              </p>
            </div>
          </div>
          <div class="comment__body">
            <p>{{ notification.comment.detail | emptyChar("[添付ファイルのみ]") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      checked: false,
    }
  },
  methods: {
    async onClickActivePart() {
      this.$emit('click-notification', this.notification.id)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';

.notifications-heading-mark {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: $grey16;
  &--marked {
    background: $pink;
  }
}

.notifications{
  &__heading{
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
  }
}

.comment{
  &__item {
    background-color: $grey15;
    padding: 8px;
  }

  &__img{
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
  &__name{
    font-weight: bold;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
  &__body{
    white-space:pre-wrap;
    word-wrap:break-word;
    color: $grey04;
  }
}

</style>